import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Button, Box, Label } from 'fw/components';
import { FileUpload, Form } from 'fw/forms';

class FileUploadDemo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			form: {
				defaultFiles: [],
				multipleFiles: [],
				requiredFiles: [],
				autoFiles: [],
				presetFiles: [{
					storageToken: "DemoToken",
					fileName: "DemoFile.pdf"
				}]
			}
		};
	}

	onChange = (form, field, prev) => {
		this.setState({ form });
	}

	onSubmit = () => {
		alert(JSON.stringify(this.state.form));
	}

	render() {
		return (
			<Box title="FileUpload">
				<Form
					onChange={this.onChange}
					values={this.state.form}
					onSubmit={this.onSubmit}>
					<Row>
						<Col md={6}>
							<Label htmlFor="defaultFiles">Default</Label>
							<FileUpload name="defaultFiles" />

							<Label htmlFor="multipleFiles">Multiple</Label>
							<FileUpload name="multipleFiles" multiple autoupload />

							<Label htmlFor="requiredFiles" required>Required</Label>
							<FileUpload name="requiredFiles" required={true} />
						</Col>
						<Col md={6}>
							<Label htmlFor="autoFiles">Preset</Label>
							<FileUpload name="presetFiles" />

							<Label htmlFor="autoFiles">Specific Folder</Label>
							<FileUpload name="specificFolder" folder="demo" />

							<Label htmlFor="autoFiles">Only some extensions allowed</Label>
							<FileUpload name="specificFolder" accept="PDF" />
						</Col>
					</Row>
					<hr />
					<Button id="btnSubmit" type="submit" className="pull-right">Submit</Button>
				</Form>
			</Box>
		);
	}
}

export default FileUploadDemo;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/FileUploads/FileUploadDemo.js